// API service for payments
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class PaymentService {
  static async createPayment(payment, token) {
    const res = await fetch(`${API_BASE_URL}/payments`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payment)
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || `HTTP ${res.status}`);
    return data.data;
  }

  static async listByPatient(patientId, token, limit = 100, lastKey = null) {
    let url = `${API_BASE_URL}/payments/patient/${patientId}?limit=${limit}`;
    if (lastKey) url += `&lastKey=${encodeURIComponent(JSON.stringify(lastKey))}`;
    const res = await fetch(url, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || `HTTP ${res.status}`);
    return data;
  }

  static async refundPayment(id, refundAmount, refundNote, token) {
    const res = await fetch(`${API_BASE_URL}/payments/${id}/refund`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ refundAmount, refundNote })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || `HTTP ${res.status}`);
    return data;
  }

  static async deletePayment(id, token) {
    const res = await fetch(`${API_BASE_URL}/payments/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || `HTTP ${res.status}`);
    return data;
  }
}

export default PaymentService;
